import React, { useEffect, useState, useRef } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { MdModeEdit } from "react-icons/md";
import { IoMdCheckmark } from "react-icons/io";
import AttachmentGrid from "./Attachmentlist";
import "./meetingdetails.css"
import Hexapi from "../../utility/HexAPI/Hexapi";
import { Modal } from "react-bootstrap";
import Loader from "../../components/loader/Loader";
import { showCustomSwal } from "../../components/customswal/Customswal";
import { ViewComponent } from "../../components/attachment/ViewComponent";
import { showConfirm } from "../../utility/showconfirm";

const MomDrawer = ({ showMom, setShowMom, attachments, mominfo ,userid,GetMeetingDetails}) => {
  const [meetingInfoState, setMeetingInfo] = useState(mominfo?.mom || "");
  const [isEditing, setIsEditing] = useState(false);
  const [attachmentIds, setAttachmentIds] = useState([]);
  const [attachmentobj,setattachmentobj]=useState(null)
  const [viewshow,setviewshow]=useState(false)
   const[loading,setloading]=useState(false)
   const handleDeleteAttachment = async(doc) => {
const result= await showConfirm({
content: `Are you sure you want to delete ${doc.filename}?`,
  okText:"Yes",
  cancelText:"No",
  hideCancel:false
})
if(!result) return
setloading(true)
try {
    
   let queryData = {
                query: `[HRApp_Droid_Proc_DeleteAttachment_Submit] @AttachmentID='{0}', @ActivityType='{1}',@UserID='{2}'`,
                queryArr: [`${doc.attachmentid}`,`${3}`, `${userid}`]
            }
            const resp = await Hexapi(queryData)
            if(resp && resp[""] && resp[""][0]){
          const command =resp[""][0]?.command
     if (command == 1) {
        const updatedAttachments = attachmentIds.filter(
    item => item.attachmentid !== doc.attachmentid
  );

  setAttachmentIds(updatedAttachments);
 updateMom(updatedAttachments)
     }else{
showCustomSwal(resp[""][0]?.msg)
     }}

} catch (error) {
  console.log(error)
}finally{
  setloading(false)
}
  
};
  useEffect(()=>{
    
    console.log(attachments,"console.log(attachments)")
    if(attachments.length > 0) {
      
      setAttachmentIds(attachments)
    }
  },[attachments])
  const textareaRef = useRef(null);

  useEffect(() => {
  if (showMom && isEditing) {
    setTimeout(() => {
      textareaRef.current?.focus();
    }, 0);
  }
}, [showMom, isEditing]);

  const handleFileUpload = async(file) => {
    try {
      setloading(true)
        console.log("Selected File:", file);
     let obj = {
            filename: file.name,
            extension: '.'+/[^.]+$/.exec(file.name)[0]
        }
  let queryData = {
            query: `HRApp_Droid_Proc_AddAttachment_Submit @ActivityType='{0}',@Attachment=$%$File$%$,@Extension='{1}',@Filename='{2}',@UserID='{3}'`,
            queryArr: [`${3}`, `${obj.extension}`, `${obj.filename}`, `${userid}`],
            file: file
        }

        const resp= await Hexapi(queryData)
        if(resp && resp[""] && resp[""][0]){
          const command =resp[""][0]?.command
     if (command == 1) {
  const newAttachmentIds = [
    ...attachmentIds,
    resp[""][0]
  ];

  setAttachmentIds(newAttachmentIds);

  updateMom(newAttachmentIds);
}else{
  showCustomSwal(resp[""][0]?.msg)
}
        }
  
        console.log(resp,"resp")
    } catch (error) {
      console.log(error)
    }finally{
      setloading(false)
    }
  
  };
const updateMom=async(ids)=>{
  console.log("cgfdshgjk")
  const getattachmentsids = ids ? ids.map((res)=>res.attachmentid) :  attachmentIds.map((res)=>res.attachmentid)
      console.log(getattachmentsids,"getattachmentsids")
  const attIds=getattachmentsids?.join(",")
  setloading(true)
  try {
    const obj={
query:`HRApp_Droid_Proc_User_Meeting_MOM_SubmitV2 @UserID='{0}',@MeetingID='{1}',@MOM='{2}',@AttachmentIds='{3}'`,
queryArr:[`${userid}`,`${mominfo?.meetingid}`,`${meetingInfoState}` , `${attIds}`]
  }

  const resp= await Hexapi(obj)
  setIsEditing(false);
  if(resp){
    if(resp[""][0].command == 1){
      showCustomSwal(resp[""][0].msg)
      GetMeetingDetails(true)
    }else{
       showCustomSwal(resp[""][0].msg)
    }
  }
  console.log(resp,"resp")
  } catch (error) {
    
  }finally{
    setloading(false)
  }
  
}
const onDocClick=(doc)=>{
console.log(doc,"doc")
setattachmentobj(doc)
setviewshow(true)
}

  return (
    <div className={`momDrawer ${showMom ? "open" : ""}`} style={{zIndex:10}}>
      <div className="momDrawerHeader">
        <span className="momdes">Minutes Of Meeting</span>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
          {!isEditing && (
            <MdModeEdit
              style={{ cursor: "pointer", fontSize: "20px" }}
              onClick={() => setIsEditing(true)}
            />
          )}
          {isEditing && (
            <IoMdCheckmark 
              style={{ cursor: "pointer", fontSize: "20px" }}
              onClick={()=>updateMom()}
            />
          )}
          <AiOutlineClose
            style={{ cursor: "pointer", fontSize: "20px" }}
            onClick={() => setShowMom(false)}
          />
        </div>
      </div>

      <div className="momDrawerBody">
        <div className="momSection" style={{ maxHeight: "200px" }}>
          <textarea
            ref={textareaRef}
            className="momInput"
            value={meetingInfoState}
            onChange={(e) => setMeetingInfo(e.target.value)}
            placeholder=""
            readOnly={!isEditing} 
            style={{
              cursor: isEditing ? "text" : "default",
            }}
          />
        </div>

        <div className="attachmentSection">
          <AttachmentGrid
            attachments={attachmentIds}
            onFileSelect={(e) => handleFileUpload(e)}
            onDocClick={(doc) => onDocClick(doc)}
            onDelete={handleDeleteAttachment}
          />
        </div>
      </div>
{
  loading && <Modal style={{zIndex:10}} centered show={loading}>
<Modal.Body>
<Loader/>
</Modal.Body>
      </Modal>
}
      {
               (attachmentobj !==null  &&  viewshow) &&  <ViewComponent userid={userid} passid={attachmentobj.attachmentid} ids={userid} filenames={attachmentobj.filename} fileExt={attachmentobj.fileext} closeModal={() => setviewshow(false)} isViewModalOpen={viewshow} />
              }
    </div>
  );
};

export default MomDrawer;